import { render, staticRenderFns } from "./video_00.vue?vue&type=template&id=3b8f3e72&scoped=true&"
import script from "./video_00.vue?vue&type=script&lang=js&"
export * from "./video_00.vue?vue&type=script&lang=js&"
import style0 from "./video_00.vue?vue&type=style&index=0&id=3b8f3e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f3e72",
  null
  
)

export default component.exports